module.exports = __webpack_public_path__ + "static/media/WebsiteBlocker1.ad67ce91.png";